const getCookie = (name) =>
  document.cookie
    .split(";")
    .map((item) => item.trim().split("="))
    .find(([key]) => key === name)?.[1] || "";

export const saveUser = (user, csrfToken) => {
  sessionStorage.setItem("authUser", JSON.stringify(user));
  sessionStorage.setItem("user_id", user.id);
  sessionStorage.setItem("user_name", user.user_name || user.userName || "");
  sessionStorage.setItem("user_email", user.email || "");
  sessionStorage.setItem("user_role", user.role || "");
  sessionStorage.setItem("animal_avatar", user.animal_avatar || "");
  if (csrfToken) sessionStorage.setItem("csrfToken", csrfToken);
};

export const updateStoredUser = (partial = {}) => {
  const current = getUser() || {};
  const next = { ...current, ...partial };
  saveUser(next, getCsrfToken());
  return next;
};

export const getUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem("authUser")) || null;
  } catch {
    return null;
  }
};

export const getCsrfToken = () =>
  sessionStorage.getItem("csrfToken") || getCookie("epona_csrf");

export const clearSession = () => {
  sessionStorage.clear();
};

export const isAdmin = () => getUser()?.role === "admin";
